import commonService from 'utils/commonService';
import apiService from 'bff/services/apiService';
import { LinkCategory } from 'constants/enums/linkCategory.enum';
import { CodeClass } from 'constants/enums/codeClass.enum';
import { Header, Links, Footer } from 'bff/models/link';
import { BaseRes } from 'bff/models/base/baseRes';
import { Codes } from 'bff/models/info';
import { MainLayout } from 'constants/models/components/mainLayout';

/**
 * @description 主版頁面初始設定資料方法
*/
const fetchInitSetting = async (lng?: string):Promise<MainLayout> => {
  let baseReq = commonService.getApiReqData();
  if (lng) {
    baseReq = commonService.getApiReqData({ LOCALE: lng });
  }
  const reqConfig = commonService.getReqConfig();

  const result = await Promise.all([
    apiService.fetchLinkByCategory(baseReq, reqConfig, LinkCategory.Header),
    apiService.fetchLinkByCategory(baseReq, reqConfig, LinkCategory.Footer),
    apiService.fetchCodes(baseReq, reqConfig, CodeClass.UI)
  ]).then(([headerLinksRes, footerLinksRes, codeTablesRes]) => {
    const headerLinksBaseRes:BaseRes<Links<Header>> = { ...headerLinksRes };
    const footerLinksBaseRes:BaseRes<Links<Footer>> = { ...footerLinksRes };
    const codeTablesBaseRes:BaseRes<Codes> = { ...codeTablesRes };

    const res:MainLayout = {
      headerLinks: commonService.arrayTypeReturn(headerLinksBaseRes.TRANRS.LINKS?.HEADER),
      footerLinks: commonService.arrayTypeReturn(footerLinksBaseRes.TRANRS.LINKS?.FOOTER),
      codeTables: commonService.arrayTypeReturn(codeTablesBaseRes.TRANRS.CODES)
    };

    return res;
  });

  return result;
};

export default {
  fetchInitSetting
};
